
import {IdentityDoc} from '@pp-frontend/shared-packages/types/dto/IdentityDoc'
import {Component, Prop, Vue} from 'nuxt-property-decorator'

@Component
export default class DocWidgetListItem extends Vue {
  @Prop() doc: IdentityDoc
}
